/*
 * Frontend bootstrap javascript
 *
 * All plugins you want to use can be listed below
 * Do NOT forgot to add comments above the different functions or functionalities that need explaining.
 *
 */
// jQuery 
window.jQuery = require('jquery');
window.$ = window.jQuery;


/**
 * Load Foundation and plugins
 * @credits: https://github.com/zurb/foundation-sites/blob/v6.4.3/js/entries/foundation.js
 * @author Rick van der Burg <rick@click.nl>
 */
import {Foundation} from 'foundation-sites/js/foundation.core';
Foundation.addToJquery($);

import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';
Foundation.MediaQuery = MediaQuery;

import { Box } from 'foundation-sites/js/foundation.util.box'
Foundation.Box = Box;

import { Tooltip } from 'foundation-sites/js/foundation.tooltip';
Foundation.plugin(Tooltip, 'Tooltip');

import { Triggers } from 'foundation-sites/js/foundation.util.triggers';
Triggers.init($, Foundation);

import { Interchange } from 'foundation-sites/js/foundation.interchange';
Foundation.plugin(Interchange, 'Interchange');

import { Accordion } from 'foundation-sites/js/foundation.accordion';
Foundation.plugin(Accordion, 'Accordion');

// init polyfill for axios (to prevent Promise is undefined)
require('es6-promise').polyfill();

window.axios = require('axios');

// Slider.js
require('slick-carousel/slick/slick.min.js');


// WEBPACK FOOTER //
// ./resources/assets/js/frontend/bootstrap.js